class BackToTop {
    constructor(options = {}) {
        this.options = {
            threshold: options.threshold || 200,
            scrollUpThreshold: options.scrollUpThreshold || 10,
            hideOnScrollDown: options.hideOnScrollDown !== false,
            ...options
        };
        
        this.lastScrollY = window.scrollY;
        this.isScrollingUp = false;
        this.button = null;
        
        this.init();
    }
    
    init() {
        this.button = document.querySelector('[data-back-to-top]');
        if (!this.button) return;
        
        // Initially hide the button
        this.button.style.opacity = '0';
        this.button.style.pointerEvents = 'none';
        this.button.style.transition = 'opacity 0.3s ease-in-out';
        
        this.bindEvents();
    }
    
    bindEvents() {
        window.addEventListener('scroll', this.handleScroll.bind(this), { passive: true });
        this.button.addEventListener('click', this.handleClick.bind(this));
    }
    
    handleScroll() {
        const currentScrollY = window.scrollY;
        const scrollDifference = this.lastScrollY - currentScrollY;
        
        // Determine if user is scrolling up
        this.isScrollingUp = scrollDifference > this.options.scrollUpThreshold;
        
        // Show/hide button based on conditions
        const shouldShow = this.options.hideOnScrollDown 
            ? currentScrollY > this.options.threshold && this.isScrollingUp
            : currentScrollY > this.options.threshold;
        
        if (shouldShow) {
            this.showButton();
        } else {
            this.hideButton();
        }
        
        this.lastScrollY = currentScrollY;
    }
    
    showButton() {
        if (this.button) {
            this.button.style.opacity = '1';
            this.button.style.pointerEvents = 'auto';
        }
    }
    
    hideButton() {
        if (this.button) {
            this.button.style.opacity = '0';
            this.button.style.pointerEvents = 'none';
        }
    }
    
    handleClick(event) {
        event.preventDefault();
        window.scrollTo({ 
            top: 0, 
            behavior: 'smooth' 
        });
    }
}

export default BackToTop;
